import { Main } from '@shared/models/Main.model';

export class Ranking extends Main {
  id: number = -1;
  avatar: string = '';
  name: string = '';
  score: string = '';
  [key: string]: any;
}
